/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */function startOfTomorrow(){var now=new Date();var year=now.getFullYear();var month=now.getMonth();var day=now.getDate();var date=new Date(0);date.setFullYear(year,month,day+1);date.setHours(0,0,0,0);return date;}module.exports=startOfTomorrow;